import League, { LeagueConfig } from '@leagueplatform/core';

export const LeagueProvider = ({
  config,
  children,
  treatConfigAsInitialOnly = false,
}: {
  config: LeagueConfig;
  children: React.ReactNode;
  treatConfigAsInitialOnly?: boolean;
}) => (
  <League.LeagueProvider
    config={config}
    treatConfigAsInitialOnly={treatConfigAsInitialOnly}
  >
    {children}
  </League.LeagueProvider>
);
